const MenuIcon = () => {
  return (
    <svg width="24" height="18" viewBox="0 0 24 18" fill="currentcolor" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_49_143)">
        <path d="M23 0H1C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2H23C23.5523 2 24 1.55228 24 1C24 0.447715 23.5523 0 23 0Z" />
        <path d="M23 8H1C0.447715 8 0 8.44772 0 9C0 9.55228 0.447715 10 1 10H23C23.5523 10 24 9.55228 24 9C24 8.44772 23.5523 8 23 8Z" />
        <path d="M23 16H1C0.447715 16 0 16.4477 0 17C0 17.5523 0.447715 18 1 18H23C23.5523 18 24 17.5523 24 17C24 16.4477 23.5523 16 23 16Z" />
      </g>
    </svg>
  );
};

export default MenuIcon;
